export default function () {
	return {
		search: '',
		selected_areas: { label: 'all_f', value: 'all' },
		selected_tags: []
	}
}
